// AddStudent.js (Updated with working Next/Back buttons and Documents tab)
import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import DropDownField from "../../DropDownField";
import {
  Box,
  Paper,
  Grid,
  TextField,
  Typography,
  Button,
  Chip,
  IconButton,
  Avatar,
  Stack,
  Divider,
  InputAdornment,
  CircularProgress,
  FormControl,
  FormHelperText,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormLabel,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardMedia,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SearchIcon from "@mui/icons-material/Search";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import {
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import apiEndpoints from "../../apiconfig";

const CLASS_OPTIONS = [
  "LKG",
  "UKG",
  "Grade 1",
  "Grade 2",
  "Grade 3",
  "Grade 4",
  "Grade 5",
  "Grade 6",
  "Grade 7",
  "Grade 8",
  "Grade 9",
  "Grade 10",
  "Grade 11",
  "Grade 12",
];

const GENDER_OPTIONS = ["Male", "Female", "Other"];
const STATUS_OPTIONS = ["Active", "Inactive"];

const initialFormState = {
  branch: "",
  firstName: "",
  lastName: "",
  gender: "",
  dob: "",
  class: "",
  class_name: "",
  parentName: "",
  parentPhone: "",
  parentEmail: "",
  parentPassword: "",
  address: "",
  joiningDate: "",
  status: "Active",
  medicalInfo: "",
  emergencyContact: "",
  previousSchool: "",
  documents: [],
  photo: "",
  parentPhoto: "", // Add this
  motherPhoto: "",
  religion: "",
  nationality: "",
  motherTongue: "",
  placeOfBirth: "",
  placeOfOrigin: "",
  bloodGroup: "",

  // Mother
  motherName: "",
  motherQualification: "",
  motherOccupation: "",
  motherWorkPlace: "",
  motherOfficialAddress: "",
  motherEmail: "",
  motherMobile: "",

  // Medical
  allergies: "",
  surgeries: "",
  chronicIllness: "",
  immunization: "",

  // Emergency Contact
  emergencyContactName: "",
  emergencyContactPhone: "",
  emergencyRelationship: "",

  // Guardian
  guardianName: "",
  guardianRelationship: "",
  guardianPhone: "",
  guardianMobile: "",

  // Previous School/Day Care
  previouslyAttendedSchool: "no", // "yes" or "no"
  previousSchoolName: "",
  previousSchoolDuration: "",
  previousSchoolClass: "",

  // Sibling Details
  siblings: [],

  // Checklist with file uploads
  birthCertificate: false,
  birthCertificateFile: null,
  immunizationRecord: false,
  immunizationRecordFile: null,
  transferCertificate: false,
  transferCertificateFile: null,
  progressReport: false,
  progressReportFile: null,
  passportPhotos: false,
  passportPhotosFile: null,
  medicalReport: false,
  medicalReportFile: null,
  passportCopy: false,
  passportCopyFile: null,
  otherDocuments: false,
  otherDocumentsFile: null,

  // Declaration
  declarationAccepted: false,
  declarationParentName: "",
  declarationChildName: "",
  declarationDate: "",
  declarationSignature: "",
};

const AddStudentForm = ({
  onSubmit,
  mode = "add",
  initialData,
  onClose: externalOnClose,
}) => {
  const navigate = useNavigate();
  const mobileInputRef = useRef(null);

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [photoPreview, setPhotoPreview] = useState(null);
  const [parentPhotoPreview, setParentPhotoPreview] = useState(null); // Add this
  const [motherPhotoPreview, setMotherPhotoPreview] = useState(null); // Add this
  const [parentPhotoError, setParentPhotoError] = useState(""); // Add this
  const [motherPhotoError, setMotherPhotoError] = useState(""); // Add this
  const [documentsChips, setDocumentsChips] = useState([]);
  const [documentInput, setDocumentInput] = useState("");
  const [photoError, setPhotoError] = useState("");
  const [branches, setBranches] = useState([]);
  const [classes, setClasses] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [isCheckingParent, setIsCheckingParent] = useState(false);
  const [parentData, setParentData] = useState(null);
  const [actualStep, setActualStep] = useState(0);
  const [parentError, setParentError] = useState("");
  const [documents, setDocuments] = useState([]);
  const [parentFieldsDisabled, setParentFieldsDisabled] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [viewDocumentsTab, setViewDocumentsTab] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [checklistDocuments, setChecklistDocuments] = useState({});

  const steps = [
    "Student & Parent Details",
    "Family & Medical Details",
    "Sibling & Previous School",
    "Documents & Declaration",
    ...(viewDocumentsTab ? ["View Documents"] : []),
  ];

  const getFileIcon = (fileName) => {
    if (!fileName) return <InsertDriveFileIcon />;

    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext)) return <PictureAsPdfIcon color="error" />;
    if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext))
      return <ImageIcon color="primary" />;
    return <InsertDriveFileIcon />;
  };

  const getFileType = (fileName) => {
    if (!fileName) return "File";

    const ext = fileName.split(".").pop().toLowerCase();
    const typeMap = {
      pdf: "PDF Document",
      zip: "ZIP Archive",
      jpg: "JPEG Image",
      jpeg: "JPEG Image",
      png: "PNG Image",
      gif: "GIF Image",
      doc: "Word Document",
      docx: "Word Document",
      xls: "Excel Spreadsheet",
      xlsx: "Excel Spreadsheet",
      txt: "Text File",
      csv: "CSV File",
    };

    return typeMap[ext] || `${ext.toUpperCase()} File`;
  };
  const handleParentPhotoChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setParentPhotoError("Please select an image file (JPEG, PNG, etc.)");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setParentPhotoError("File size should be less than 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const url = e.target.result;
      setFormData((prev) => ({
        ...prev,
        parentPhoto: url,
      }));
      setParentPhotoPreview(url);
      setParentPhotoError("");
    };
    reader.readAsDataURL(file);
  };
  useEffect(() => {
    // Lock scroll
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    return () => {
      // Restore scroll when modal closes
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const handleMotherPhotoChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setMotherPhotoError("Please select an image file (JPEG, PNG, etc.)");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setMotherPhotoError("File size should be less than 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const url = e.target.result;
      setFormData((prev) => ({
        ...prev,
        motherPhoto: url,
      }));
      setMotherPhotoPreview(url);
      setMotherPhotoError("");
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveParentPhoto = () => {
    if (parentPhotoPreview && parentPhotoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(parentPhotoPreview);
    }

    setParentPhotoPreview(null);
    setFormData((prev) => ({
      ...prev,
      parentPhoto: "",
    }));
    setParentPhotoError("");
  };

  const handleRemoveMotherPhoto = () => {
    if (motherPhotoPreview && motherPhotoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(motherPhotoPreview);
    }

    setMotherPhotoPreview(null);
    setFormData((prev) => ({
      ...prev,
      motherPhoto: "",
    }));
    setMotherPhotoError("");
  };
  const handleDownloadFile = (base64Data, fileName) => {
    if (!base64Data) {
      alert("No file data available");
      return;
    }

    try {
      let mimeType = "application/octet-stream";
      let base64Content = base64Data;

      // If full data URL exists
      if (base64Data.startsWith("data:")) {
        const mimeMatch = base64Data.match(/^data:([^;]+);/);
        if (mimeMatch) {
          mimeType = mimeMatch[1];
        }

        // Extract base64 content
        const commaIndex = base64Data.indexOf(",");
        if (commaIndex !== -1) {
          base64Content = base64Data.substring(commaIndex + 1);
        }
      }

      // Clean up base64 string (remove any whitespace)
      base64Content = base64Content.replace(/\s/g, "");

      // Decode base64
      const byteCharacters = atob(base64Content);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // If MIME type is still generic, try to determine from filename
      if (mimeType === "application/octet-stream" && fileName) {
        const extension = fileName.split(".").pop().toLowerCase();
        const mimeMap = {
          pdf: "application/pdf",
          zip: "application/zip",
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          png: "image/png",
          gif: "image/gif",
          doc: "application/msword",
          docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          xls: "application/vnd.ms-excel",
          xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          txt: "text/plain",
          csv: "text/csv",
        };

        if (mimeMap[extension]) {
          mimeType = mimeMap[extension];
        }
      }

      const blob = new Blob([byteArray], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "document";

      // Add timestamp to filename to avoid cache issues
      if (!fileName) {
        const timestamp = new Date().getTime();
        link.download = `document_${timestamp}`;
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Cleanup
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Error downloading file:", error);
      console.error(
        "Base64 data first 100 chars:",
        base64Data?.substring(0, 100),
      );
      alert(`Error downloading file: ${error.message || "Invalid file data"}`);
    }
  };

  const handleViewFile = (base64Data, fileName, fileType) => {
    if (!base64Data) {
      alert("No file data available");
      return;
    }

    const isImage = fileType && fileType.toLowerCase().includes("image");

    if (isImage) {
      setSelectedFile({
        data: base64Data,
        name: fileName,
        type: "image",
      });
    } else {
      try {
        let mimeType = "application/pdf"; // Default to PDF
        let base64Content = base64Data;

        // Extract from data URL if present
        if (base64Data.startsWith("data:")) {
          const mimeMatch = base64Data.match(/^data:([^;]+);/);
          if (mimeMatch) {
            mimeType = mimeMatch[1];
          }

          const commaIndex = base64Data.indexOf(",");
          if (commaIndex !== -1) {
            base64Content = base64Data.substring(commaIndex + 1);
          }
        } else if (fileName) {
          // Determine MIME type from file extension
          const extension = fileName.split(".").pop().toLowerCase();
          const mimeMap = {
            pdf: "application/pdf",
            zip: "application/zip",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            txt: "text/plain",
            csv: "text/csv",
          };

          if (mimeMap[extension]) {
            mimeType = mimeMap[extension];
          }
        }

        // Clean base64
        base64Content = base64Content.replace(/\s/g, "");

        const byteCharacters = atob(base64Content);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const url = URL.createObjectURL(blob);

        // For PDFs, open in new tab
        if (mimeType === "application/pdf") {
          window.open(url, "_blank");
        } else {
          // For other files, trigger download
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName || "document";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Cleanup
        setTimeout(() => URL.revokeObjectURL(url), 5000);
      } catch (error) {
        console.error("Error viewing file:", error);
        alert(`Error opening file: ${error.message || "Invalid file format"}`);
      }
    }
  };

  const handleCloseFileModal = () => {
    setSelectedFile(null);
  };

  const renderDocumentsGrid = () => {
    const documentsList = [];

    if (formData.photo) {
      documentsList.push({
        type: "Profile Photo",
        file: formData.photo,
        fileName: "profile_photo.jpg",
        isImage: true,
      });
    }
    if (formData.parentPhoto) {
      documentsList.push({
        type: "Parent Profile Photo",
        file: formData.parentPhoto,
        fileName: "parent_profile.jpg",
        isImage: true,
      });
    }

    if (formData.motherPhoto) {
      documentsList.push({
        type: "Mother Profile Photo",
        file: formData.motherPhoto,
        fileName: "mother_profile.jpg",
        isImage: true,
      });
    }
    Object.entries(checklistDocuments).forEach(([key, doc]) => {
      if (doc && doc.file) {
        const isImage =
          doc.fileName &&
          [
            ".jpg",
            ".jpeg",
            ".png",
            ".gif",
            ".bmp",
            ".webp",
            ".pdf",
            ".excel",
            ".doc",
            ".zip",
          ].some((ext) => doc.fileName.toLowerCase().endsWith(ext));
        documentsList.push({
          ...doc,
          key,
          isImage,
        });
      }
    });

    if (documents && Array.isArray(documents)) {
      documents.forEach((doc, index) => {
        if (doc.file_data) {
          const isImage =
            doc.document_type &&
            ["Profile Photo", "Passport Photos"].includes(doc.document_type);
          documentsList.push({
            type: doc.document_type || "Document",
            file: doc.file_data,
            fileName: doc.file_name || `document_${index + 1}`,
            isImage,
          });
        }
      });
    }

    if (documentsList.length === 0) {
      return (
        <Box sx={{ textAlign: "center", py: 8 }}>
          <ImageIcon sx={{ fontSize: 60, color: "text.disabled", mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            No documents found
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Upload documents in the "Documents & Declaration" tab
          </Typography>
        </Box>
      );
    }

    return (
      <Grid container spacing={3}>
        {documentsList.map((doc, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 6,
                },
              }}
            >
              <Box sx={{ position: "relative", pt: "75%" }}>
                {doc.isImage ? (
                  <CardMedia
                    component="img"
                    image={doc.file}
                    alt={doc.fileName}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleViewFile(doc.file, doc.fileName, doc.type)
                    }
                  />
                ) : (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "background.default",
                      p: 2,
                    }}
                  >
                    {getFileIcon(doc.fileName)}
                    <Typography
                      variant="caption"
                      sx={{ mt: 1, textAlign: "center" }}
                    >
                      {getFileType(doc.fileName)}
                    </Typography>
                  </Box>
                )}
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    bgcolor: "background.paper",
                    "&:hover": {
                      bgcolor: "background.paper",
                    },
                  }}
                  onClick={() => handleDownloadFile(doc.file, doc.fileName)}
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
                {doc.isImage && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 48,
                      bgcolor: "background.paper",
                      "&:hover": {
                        bgcolor: "background.paper",
                      },
                    }}
                    onClick={() =>
                      handleViewFile(doc.file, doc.fileName, doc.type)
                    }
                  >
                    <ZoomInIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              <CardContent sx={{ flexGrow: 1, p: 2 }}>
                <Typography variant="subtitle2" noWrap sx={{ fontWeight: 600 }}>
                  {doc.type}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap>
                  {doc.fileName}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  };

  const validateStep = (step) => {
    const newErrors = {};

    const actualStep = viewDocumentsTab && step === steps.length - 1 ? 3 : step;

    if (actualStep === 0) {
      if (!formData.firstName.trim())
        newErrors.firstName = "First name is required";
      if (!formData.dob) newErrors.dob = "Date of birth is required";
      if (!formData.gender) newErrors.gender = "Gender is required";
      if (!formData.class) newErrors.class = "Class is required";
      if (!formData.branch) newErrors.branch = "Branch is required";
      if (!formData.parentName.trim())
        newErrors.parentName = "Parent name is required";
      if (!formData.parentPhone.trim())
        newErrors.parentPhone = "Parent phone is required";
      if (!formData.address.trim()) newErrors.address = "Address is required";
      else if (!/^[0-9]{10}$/.test(formData.parentPhone.replace(/\D/g, "")))
        newErrors.parentPhone = "Enter a valid 10-digit phone number";
      if (!formData.joiningDate)
        newErrors.joiningDate = "Joining date is required";

      if (formData.dob) {
        const dobDate = new Date(formData.dob);
        const today = new Date();
        if (dobDate > today) {
          newErrors.dob = "Date of birth cannot be in the future";
        } else if (formData.class) {
          const selectedClass = classes.find((c) => c.guid === formData.class);
          if (
            selectedClass &&
            selectedClass.is_age_restricted === 1 &&
            selectedClass.dob_from &&
            selectedClass.dob_to
          ) {
            const dobStr = formData.dob;
            if (dobStr < selectedClass.dob_from || dobStr > selectedClass.dob_to) {
              const formattedFrom = new Date(selectedClass.dob_from).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
              const formattedTo = new Date(selectedClass.dob_to).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
              newErrors.dob = `Ineligible for ${selectedClass.name}. Eligible DOB: ${formattedFrom} to ${formattedTo}`;
            }
          }
        }
      }

      if (formData.dob && formData.class && !newErrors.dob) {
        const selectedClass = classes.find((c) => c.guid === formData.class);
        if (
          selectedClass &&
          selectedClass.is_age_restricted === 1 &&
          selectedClass.dob_from &&
          selectedClass.dob_to
        ) {
          const dobStr = formData.dob;
          if (dobStr < selectedClass.dob_from || dobStr > selectedClass.dob_to) {
            const formattedFrom = new Date(selectedClass.dob_from).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            });
            const formattedTo = new Date(selectedClass.dob_to).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            });
            newErrors.class = `Ineligible for ${selectedClass.name} based on DOB.`;
          }
        }
      }

      if (formData.joiningDate) {
        const joiningDate = new Date(formData.joiningDate);
        const today = new Date();
        if (joiningDate > today) {
          newErrors.joiningDate = "Joining date cannot be in the future";
        }
      }
    }

    if (actualStep === 1) {
      if (!formData.motherName.trim())
        newErrors.motherName = "Mother name is required";
    }

    if (actualStep === 3) {
      if (!formData.declarationAccepted)
        newErrors.declarationAccepted = "You must accept the declaration";
      if (!formData.declarationParentName?.trim())
        newErrors.declarationParentName = "Parent/Guardian name is required";
      if (!formData.declarationDate)
        newErrors.declarationDate = "Date is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isValidBase64Image = (str) => {
    if (!str || typeof str !== "string") return false;

    if (!str.includes("base64,")) return false;

    const base64Data = str.split("base64,")[1];
    if (!base64Data || base64Data.length < 1000) return false;

    return true;
  };

  console.log("initialData", initialData);

  const handleNext = () => {
    if (viewDocumentsTab && activeStep === steps.length - 2) {
      setActiveStep(steps.length - 1);
      return;
    }

    if (validateStep(activeStep)) {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const handleBack = () => {
    if (viewDocumentsTab && activeStep === steps.length - 1) {
      setActiveStep(steps.length - 2);
      return;
    }
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const toggleViewDocuments = () => {
    if (viewDocumentsTab) {
      setViewDocumentsTab(false);
      if (activeStep === steps.length - 1) {
        setActiveStep(steps.length - 2);
      }
    } else {
      setViewDocumentsTab(true);
    }
  };

  const [serverError, setServerError] = useState("");

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetch(`${apiEndpoints.dropdown}?type=branch`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setBranches(data.data);

          if (mode === "edit" && initialData?.branch) {
            setFormData((prev) => ({
              ...prev,
              branch: initialData.branch,
            }));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, [mode, initialData, token]);

  useEffect(() => {
    if (!formData.branch) return;

    fetch(
      `${apiEndpoints.dropdown}?type=class&branch_guid=${formData.branch}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") setClasses(data.data);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });
  }, [formData.branch, token]);

  useEffect(() => {
    if (mode !== "edit" || !initialData) return;

    console.log("Initial data for edit:", initialData);

    const fullName =
      `${initialData.firstName || ""} ${initialData.lastName || ""}`.trim();
    const parentFirstName = initialData.parent_first_name || "";
    const parentLastName = initialData.parent_last_name || "";
    const parentFullName = `${parentFirstName} ${parentLastName}`.trim();

    const motherFirstName = initialData.mother_first_name || "";
    const motherLastName = initialData.mother_last_name || "";
    const motherFullName = `${motherFirstName} ${motherLastName}`.trim();

    const emergencyContactName = initialData.emergency_contact_name || "";
    const emergencyContactPhone = initialData.emergency_contact_phone || "";
    const emergencyRelationship = initialData.emergency_relationship || "";

    const guardianName = initialData.guardian_name || "";
    const guardianRelationship = initialData.guardian_relationship || "";
    const guardianPhone = initialData.guardian_phone || "";
    const guardianMobile = initialData.guardian_mobile || "";

    const previouslyAttendedSchool =
      initialData.previously_attended_school === "yes"
        ? "yes"
        : initialData.previously_attended_school === "no"
          ? "no"
          : "no";

    const previousSchoolName = initialData.previous_school_name || "";
    const previousSchoolDuration = initialData.previous_school_duration || "";
    const previousSchoolClass = initialData.previous_school_class || "";

    const declarationParentName = initialData.declaration_parent_name || "";
    const declaration_signed_by = initialData.declaration_signed_by || "";
    const declarationDate = initialData.declaration_date || "";

    if (initialData.checklist_documents) {
      try {
        const checklistData =
          typeof initialData.checklist_documents === "string"
            ? JSON.parse(initialData.checklist_documents)
            : initialData.checklist_documents;

        setChecklistDocuments(checklistData);
      } catch (error) {
        console.error("Error parsing checklist documents:", error);
      }
    }

    const updatedFormData = {
      ...initialFormState,
      fullName: fullName,
      firstName: initialData.firstName || "",
      lastName: initialData.lastName || "",
      gender: initialData.gender || "",
      dob: initialData.dob || "",
      branch: initialData.branch_guid || "",
      class: initialData.class_guid || initialData.class || "",
      class_name: initialData.class_name || "",
      address: initialData.address || "",
      joiningDate: initialData.joiningDate || "",
      status: initialData.isActive === 1 ? "Active" : "Inactive",

      religion: initialData.religion || "",
      nationality: initialData.nationality || "",
      motherTongue: initialData.mother_tongue || "",
      placeOfBirth: initialData.place_of_birth || "",
      placeOfOrigin: initialData.place_of_origin || "",
      bloodGroup: initialData.blood_group || "",

      parentName: parentFullName,
      parentPhone:
        initialData.parentPhone || initialData.emergency_contact || "",
      parentEmail: initialData.parentEmail || "",
      parentPhoto: initialData.parent_photo || "",
      parentPassword: initialData.parentPassword || "",
      occupation: initialData.occupation || "",
      username: initialData.username || "",
      qualification: initialData.qualification || "",
      placeofwork: initialData.placeofwork || "",

      motherName: motherFullName,
      motherQualification: initialData.mother_qualification || "",
      motherOccupation: initialData.mother_occupation || "",
      motherWorkPlace: initialData.mother_work_place || "",
      motherOfficialAddress: initialData.mother_address || "",
      motherEmail: initialData.mother_email || "",
      motherMobile: initialData.mother_mobile || "",

      allergies: initialData.allergies || "",
      surgeries: initialData.surgeries || "",
      chronicIllness: initialData.chronic_illness_status || "",
      immunization: initialData.immunization_status || "",

      emergencyContactName: emergencyContactName,
      emergencyContactPhone: emergencyContactPhone,
      emergencyRelationship: emergencyRelationship,

      guardianName: guardianName,
      guardianRelationship: guardianRelationship,
      guardianPhone: guardianPhone,
      guardianMobile: guardianMobile,

      previouslyAttendedSchool: previouslyAttendedSchool,
      previousSchoolName: previousSchoolName,
      previousSchoolDuration: previousSchoolDuration,
      previousSchoolClass: previousSchoolClass,

      siblings: initialData.siblings || [],

      declarationParentName: declarationParentName,
      declarationChildName:
        `${initialData.first_name || ""} ${initialData.last_name || ""}`.trim(),
      declarationDate: declarationDate,
      declarationSignature: declaration_signed_by,
      declarationAccepted: true,

      documents: initialData.documents || [],
      photo: initialData.profile_photo || "",

      birthCertificate:
        initialData.birth_certificate_submitted === "Yes" || false,
      immunizationRecord:
        initialData.immunization_record_submitted === "Yes" || false,
      transferCertificate:
        initialData.transfer_certificate_submitted === "Yes" || false,
      progressReport: initialData.progress_report_submitted === "Yes" || false,
      passportPhotos: initialData.passport_photos_submitted === "Yes" || false,
      passportCopy: initialData.passport_copy_submitted === "Yes" || false,
      medicalReport: initialData.medical_report_submitted === "Yes" || false,
      otherDocuments: initialData.other_documents_submitted === "Yes" || false,

      birthCertificateFile: initialData.birth_certificate_file || null,
      immunizationRecordFile: initialData.immunization_record_file || null,
      transferCertificateFile: initialData.transfer_certificate_file || null,
      progressReportFile: initialData.progress_report_file || null,
      passportPhotosFile: initialData.passport_photos_file || null,
      passportCopyFile: initialData.passport_copy_file || null,
      medicalReportFile: initialData.medical_report_file || null,
      otherDocumentsFile: initialData.other_documents_file || null,
    };

    console.log("Updated form data:", updatedFormData);
    setFormData(updatedFormData);
    if (initialData.documents && Array.isArray(initialData.documents)) {
      setDocuments(initialData.documents);
    }

    if (initialData.profile_photo) {
      console.log("Setting photo preview:", initialData.profile_photo);
      let photo = initialData.profile_photo;

      if (!photo.startsWith("data:") && !photo.startsWith("http")) {
        photo = `data:image/jpeg;base64,${photo}`;
      }

      setPhotoPreview(photo);

      setFormData((prev) => ({
        ...prev,
        photo: photo,
      }));
    }

    if (initialData.documents && Array.isArray(initialData.documents)) {
      setDocumentsChips(initialData.documents);
    }

    if (initialData.parent_phone) {
      const parent = {
        guid: initialData.parent_guid || generateTempGuid(),
        first_name: parentFirstName,
        last_name: parentLastName,
        email: initialData.parent_email || "",
        mobile: initialData.parent_phone || "",
        address: initialData.address || "",
      };

      setParentData(parent);
      setParentFieldsDisabled(false);
      setParentError(`Editing student for parent: ${parentFullName}`);
    }

    if (initialData.branch_guid) {
      fetch(
        `${apiEndpoints.dropdown}?type=class&branch_guid=${initialData.branch_guid}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.status !== "success") return;

          setClasses(data.data);

          const matchedClass = data.data.find(
            (c) => c.guid === (initialData.class_guid || initialData.class),
          );

          if (matchedClass) {
            setFormData((prev) => ({
              ...prev,
              class: matchedClass.guid,
            }));
          }
        })
        .catch((error) => {
          console.error("Error fetching classes for edit:", error);
        });
    }
    if (initialData.parent_photo) {
      let parentPhoto = initialData.parent_photo;
      if (!parentPhoto.startsWith("data:") && !parentPhoto.startsWith("http")) {
        parentPhoto = `data:image/jpeg;base64,${parentPhoto}`;
      }
      setParentPhotoPreview(parentPhoto);
      setFormData((prev) => ({
        ...prev,
        parentPhoto: parentPhoto,
      }));
    }

    // Handle mother photo
    if (initialData.mother_photo) {
      let motherPhoto = initialData.mother_photo;
      if (!motherPhoto.startsWith("data:") && !motherPhoto.startsWith("http")) {
        motherPhoto = `data:image/jpeg;base64,${motherPhoto}`;
      }
      setMotherPhotoPreview(motherPhoto);
      setFormData((prev) => ({
        ...prev,
        motherPhoto: motherPhoto,
      }));
    }
  }, [mode, initialData, token]);

  const generateTempGuid = () => {
    return "temp-" + Math.random().toString(36).substr(2, 9);
  };

  const checkParentExists = async (mobile) => {
    if (!mobile || mobile.length < 10) {
      setParentError("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsCheckingParent(true);
    setParentError("");
    setParentData(null);

    try {
      const response = await fetch(
        `${apiEndpoints.parentcheck}?mobile=${mobile}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (data.status === "success" && data.data) {
        const parent = data.data;
        setParentData(parent);

        const fullName = `${parent.first_name || ""} ${
          parent.last_name || ""
        }`.trim();

        setFormData((prev) => ({
          ...prev,
          parentName: fullName,
          parentEmail: parent.email || "",
          address: parent.address || "",
          parentPassword: parent.password || "",
          declarationParentName: fullName,
        }));

        setParentFieldsDisabled(true);
        setParentError(
          `✓ Parent found: ${fullName}. Fields are locked. Click 'Unlock' to edit.`,
        );
      } else {
        setParentData(null);
        setParentFieldsDisabled(false);
        setParentError(
          "No parent found with this mobile number. You can enter new parent details.",
        );

        setFormData((prev) => ({
          ...prev,
          parentName: "",
          parentEmail: "",
          address: "",
          parentPassword: "",
          declarationParentName: "",
        }));
      }
    } catch (error) {
      console.error("Error checking parent:", error);
      setParentError("Error checking parent. Please try again.");
      setParentFieldsDisabled(false);
      setParentData(null);
    } finally {
      setIsCheckingParent(false);
    }
  };

  const handleChange = (field) => (event) => {
    const value = event.target.value;

    if (field === "parentPhone" && parentData && mode !== "edit") {
      setParentData(null);
      setParentFieldsDisabled(false);
      setParentError("");

      setFormData((prev) => ({
        ...prev,
        parentName: "",
        parentEmail: "",
        address: "",
        parentPassword: "",
        declarationParentName: "",
      }));
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleCheckboxChange = (field) => (event) => {
    const checked = event.target.checked;
    setFormData((prev) => ({
      ...prev,
      [field]: checked,
    }));
  };

  const shortenBase64 = (base64String, maxLength = 100) => {
    if (!base64String) return "";
    if (base64String.length <= maxLength) return base64String;
    return base64String.substring(0, maxLength) + "...";
  };

  const extractBase64FromFile = (fileObject) => {
    if (!fileObject) return null;

    // If it's already a base64 string
    if (typeof fileObject === "string") {
      // Check if it's a full data URL
      if (fileObject.startsWith("data:")) {
        return fileObject;
      }
      // Check if it's a partial base64 (missing data: prefix)
      else if (
        fileObject.length > 100 &&
        /^[A-Za-z0-9+/=]+$/.test(fileObject.replace(/\s/g, ""))
      ) {
        // It's likely a base64 string without prefix
        // For images, add image/jpeg prefix as default
        if (fileObject.includes("/9j/") || fileObject.includes("iVBORw")) {
          return `data:image/jpeg;base64,${fileObject}`;
        }
        // For PDFs (starts with JVBERi0)
        else if (fileObject.startsWith("JVBERi0")) {
          return `data:application/pdf;base64,${fileObject}`;
        }
        // For ZIP files (starts with PK)
        else if (fileObject.startsWith("UEsDB")) {
          return `data:application/zip;base64,${fileObject}`;
        }
        // Default to application/octet-stream
        return `data:application/octet-stream;base64,${fileObject}`;
      }
      return fileObject;
    }

    // If it's a file object with data property
    if (fileObject.data && typeof fileObject.data === "string") {
      return fileObject.data;
    }

    return null;
  };

  const handleFileUpload = (field) => async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      alert("File size should be less than 10MB");
      return;
    }

    try {
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });

      const fileData = {
        name: file.name,
        type: file.type,
        size: file.size,
        data: base64Data,
        lastModified: file.lastModified,
      };

      setFormData((prev) => ({
        ...prev,
        [field]: fileData,
      }));
    } catch (error) {
      console.error("Error reading file:", error);
      alert("Error uploading file. Please try again.");
    }
  };

  const handleUnlockFields = () => {
    setParentFieldsDisabled(false);
    setParentData(null);
    setParentError("Fields unlocked. You can edit parent details.");

    setFormData((prev) => ({
      ...prev,
      parentName: "",
      parentEmail: "",
      address: "",
      parentPassword: "",
      declarationParentName: "",
    }));
  };

  const handleDateChange = (field) => (event) => {
    const value = event.target.value;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setPhotoError("Please select an image file (JPEG, PNG, etc.)");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setPhotoError("File size should be less than 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const url = e.target.result;
      setFormData((prev) => ({
        ...prev,
        photo: url,
      }));
      setPhotoPreview(url);
      setPhotoError("");
      if (errors.photo) {
        setErrors((prev) => ({ ...prev, photo: "" }));
      }
    };
    reader.readAsDataURL(file);
  };

  const handleAddDocumentChip = () => {
    const value = documentInput.trim();
    if (!value) return;
    if (documentsChips.includes(value)) {
      setDocumentInput("");
      return;
    }

    const updated = [...documentsChips, value];
    setDocumentsChips(updated);
    setFormData((prev) => ({
      ...prev,
      documents: updated,
    }));
    setDocumentInput("");
  };

  const handleDocumentKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      handleAddDocumentChip();
    }
  };

  const handleMobileKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const mobile = formData.parentPhone.trim();
      if (mobile.length >= 10) {
        checkParentExists(mobile);
      }
    }
  };

  const handleCheckParent = () => {
    const mobile = formData.parentPhone.trim();
    checkParentExists(mobile);
  };

  const [newSibling, setNewSibling] = useState({
    name: "",
    gender: "",
    age: "",
    class: "",
    school: "",
  });

  const handleAddSibling = () => {
    if (!newSibling.name.trim()) {
      alert("Please enter sibling name");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      siblings: [...prev.siblings, { ...newSibling, id: Date.now() }],
    }));

    setNewSibling({
      name: "",
      gender: "",
      age: "",
      class: "",
      school: "",
    });
  };

  const handleRemoveSibling = (index) => {
    setFormData((prev) => ({
      ...prev,
      siblings: prev.siblings.filter((_, i) => i !== index),
    }));
  };

  const handleSiblingChange = (field) => (event) => {
    setNewSibling((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleRemovePhoto = () => {
    if (photoPreview && photoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(photoPreview);
    }

    setPhotoPreview(null);
    setFormData((prev) => ({
      ...prev,
      photo: "",
    }));
    if (errors.photo) {
      setErrors((prev) => ({ ...prev, photo: "" }));
    }
    setPhotoError("");
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;

    try {
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  const createChecklistObject = () => {
    const checklist = {};

    if (formData.birthCertificate && formData.birthCertificateFile) {
      const base64Data = extractBase64FromFile(formData.birthCertificateFile);
      if (base64Data) {
        checklist["0"] = {
          type: "Birth Certificate",
          file: shortenBase64(base64Data),
          fileName: formData.birthCertificateFile.name || "birth_certificate",
        };
      }
    }

    if (formData.immunizationRecord && formData.immunizationRecordFile) {
      const base64Data = extractBase64FromFile(formData.immunizationRecordFile);
      if (base64Data) {
        checklist["1"] = {
          type: "Immunization Record",
          file: shortenBase64(base64Data),
          fileName:
            formData.immunizationRecordFile.name || "immunization_record",
        };
      }
    }

    if (formData.transferCertificate && formData.transferCertificateFile) {
      const base64Data = extractBase64FromFile(
        formData.transferCertificateFile,
      );
      if (base64Data) {
        checklist["2"] = {
          type: "Transfer Certificate",
          file: shortenBase64(base64Data),
          fileName:
            formData.transferCertificateFile.name || "transfer_certificate",
        };
      }
    }

    if (formData.passportPhotos && formData.passportPhotosFile) {
      const base64Data = extractBase64FromFile(formData.passportPhotosFile);
      if (base64Data) {
        checklist["3"] = {
          type: "Passport Photos",
          file: shortenBase64(base64Data),
          fileName: formData.passportPhotosFile.name || "passport_photos",
        };
      }
    }

    if (formData.progressReport && formData.progressReportFile) {
      const base64Data = extractBase64FromFile(formData.progressReportFile);
      if (base64Data) {
        checklist["4"] = {
          type: "Progress Report",
          file: shortenBase64(base64Data),
          fileName: formData.progressReportFile.name || "progress_report",
        };
      }
    }

    if (formData.passportCopy && formData.passportCopyFile) {
      const base64Data = extractBase64FromFile(formData.passportCopyFile);
      if (base64Data) {
        checklist["5"] = {
          type: "Passport Copy",
          file: shortenBase64(base64Data),
          fileName: formData.passportCopyFile.name || "passport_copy",
        };
      }
    }

    if (formData.medicalReport && formData.medicalReportFile) {
      const base64Data = extractBase64FromFile(formData.medicalReportFile);
      if (base64Data) {
        checklist["6"] = {
          type: "Medical Report",
          file: shortenBase64(base64Data),
          fileName: formData.medicalReportFile.name || "medical_report",
        };
      }
    }

    if (formData.otherDocuments && formData.otherDocumentsFile) {
      const base64Data = extractBase64FromFile(formData.otherDocumentsFile);
      if (base64Data) {
        checklist["7"] = {
          type: "Other Documents",
          file: shortenBase64(base64Data),
          fileName: formData.otherDocumentsFile.name || "other_documents",
        };
      }
    }

    return checklist;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let isValid = true;
    for (let i = 0; i < steps.length; i++) {
      if (!validateStep(i)) {
        isValid = false;
        setActiveStep(i);
        break;
      }
    }

    if (!isValid) {
      return;
    }

    const buildPayloadForBackend = () => {
      const [pFirst, ...pRest] = (formData.parentName || "").trim().split(" ");
      const pLast = pRest.join(" ") || "";

      const checklistObject = createChecklistObject();

      const payload = {
        parent_first_name: pFirst || "",
        parent_last_name: pLast || "",
        occupation: formData.occupation || "",
        qualification: formData.qualification || "",
        placeofwork: formData.placeofwork || "",
        username: formData.username || "",
        parent_photo: formData.parentPhoto || undefined, // Add this
        parent_address: formData.address || "",
        email: formData.parentEmail || "",
        mobile: formData.parentPhone || "",
        password: formData.parentPassword || "",
        parent_guid: parentData ? parentData.guid : null,

        first_name: formData.firstName || "",
        last_name: formData.lastName || "",
        date_of_birth: formData.dob || "",
        gender: formData.gender || "",
        blood_group: formData.bloodGroup || "",
        class: formData.class || "",
        profile_photo:
          formData.photo && formData.photo.startsWith("data:")
            ? formData.photo
            : undefined,
        joining_date: formData.joiningDate || "",
        branch_guid: formData.branch || "",
        status: formData.status,

        mother_first_name: formData.motherName || "",
        mother_email: formData.motherEmail || "",
        mother_photo: formData.motherPhoto || undefined, // Add this
        mother_mobile: formData.motherMobile || "",
        mother_occupation: formData.motherOccupation || "",
        mother_qualification: formData.motherQualification || "",
        mother_work_place: formData.motherWorkPlace || "",
        mother_official_address: formData.motherOfficialAddress || "",

        allergies: formData.allergies || "",
        surgeries: formData.surgeries || "",
        chronic_illness: formData.chronicIllness || "",
        immunization: formData.immunization || "",

        emergency_contact_name: formData.emergencyContactName || "",
        emergency_contact_phone: formData.emergencyContactPhone || "",
        emergency_relationship: formData.emergencyRelationship || "",

        guardian_name: formData.guardianName || "",
        guardian_relationship: formData.guardianRelationship || "",
        guardian_phone: formData.guardianPhone || "",
        guardian_mobile: formData.guardianMobile || "",

        siblings: formData.siblings || [],

        previously_attended_school: formData.previouslyAttendedSchool || "no",
        previous_school_name: formData.previousSchoolName || "",
        previous_school_duration: formData.previousSchoolDuration || "",
        previous_school_class: formData.previousSchoolClass || "",

        place_of_birth: formData.placeOfBirth || "",
        place_of_origin: formData.placeOfOrigin || "",
        religion: formData.religion || "",
        nationality: formData.nationality || "",
        mother_tongue: formData.motherTongue || "",

        declaration_parent_name: formData.declarationParentName || "",
        declaration_date: formData.declarationDate || "",

        checklist_documents: checklistObject,

        birth_certificate_file: formData.birthCertificateFile
          ? extractBase64FromFile(formData.birthCertificateFile)
          : null,
        immunization_record_file: formData.immunizationRecordFile
          ? extractBase64FromFile(formData.immunizationRecordFile)
          : null,
        transfer_certificate_file: formData.transferCertificateFile
          ? extractBase64FromFile(formData.transferCertificateFile)
          : null,
        progress_report_file: formData.progressReportFile
          ? extractBase64FromFile(formData.progressReportFile)
          : null,
        passport_copy_file: formData.passportCopyFile
          ? extractBase64FromFile(formData.passportCopyFile)
          : null,
        medical_report_file: formData.medicalReportFile
          ? extractBase64FromFile(formData.medicalReportFile)
          : null,
        passport_photos_file: formData.passportPhotosFile
          ? extractBase64FromFile(formData.passportPhotosFile)
          : null,
        other_documents_file: formData.otherDocumentsFile
          ? extractBase64FromFile(formData.otherDocumentsFile)
          : null,
      };
      return payload;
    };

    const payload = buildPayloadForBackend();

    console.log("Checklist object:", payload.checklist_documents);

    if (mode === "edit" && initialData?.guid) {
      if (typeof onSubmit === "function") {
        onSubmit(payload, setServerError, initialData.guid);
      }
    } else {
      if (typeof onSubmit === "function") {
        onSubmit(payload, setServerError);
      }
    }

    if (photoPreview && photoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(photoPreview);
    }
  };

  console.log("formdata", formData);

  const handleClose = () => {
    if (photoPreview && photoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(photoPreview);
    }
    if (parentPhotoPreview && parentPhotoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(parentPhotoPreview);
    }
    if (motherPhotoPreview && motherPhotoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(motherPhotoPreview);
    }

    if (externalOnClose) {
      externalOnClose();
    } else {
      try {
        navigate(-1);
      } catch (err) {
        console.error("Navigation error:", err);
      }
    }
  };

  const truncate = (text, length = 18) =>
    text.length > length ? text.substring(0, length) + "..." : text;

  const renderStepContent = (step) => {
    let actualStep = step;
    if (viewDocumentsTab) {
      if (step === steps.length - 1) {
        return (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Uploaded Documents & Images
              </Typography>
              <Button
                variant="outlined"
                onClick={toggleViewDocuments}
                startIcon={<CloseIcon />}
              >
                Close View
              </Button>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              View all uploaded documents and images. Click on images to enlarge
              or use the download button to save files.
            </Typography>
            {renderDocumentsGrid()}
          </Box>
        );
      }
      actualStep = step > 3 ? step - 1 : step;
    }

    switch (actualStep) {
      case 0:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Student Basic Information
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <DropDownField
                label="Branch *"
                value={formData.branch}
                options={branches}
                error={Boolean(errors.branch)}
                helperText={errors.branch}
                onChange={(guid) => {
                  setFormData((prev) => ({
                    ...prev,
                    branch: guid,
                    class: "",
                  }));
                  setErrors((prev) => ({ ...prev, branch: "" }));
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="firstName"
                label="First Name *"
                placeholder="e.g. Aarav"
                value={formData.firstName}
                onChange={handleChange("firstName")}
                fullWidth
                size="medium"
                error={Boolean(errors.firstName)}
                helperText={errors.firstName}
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="lastName"
                label="Last Name"
                placeholder="e.g. Sharma"
                value={formData.lastName}
                onChange={handleChange("lastName")}
                fullWidth
                size="medium"
                helperText={errors.lastName}
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <DropDownField
                label="Gender *"
                value={formData.gender}
                options={GENDER_OPTIONS.map((g) => ({
                  guid: g,
                  name: g,
                }))}
                error={Boolean(errors.gender)}
                helperText={errors.gender}
                onChange={(value) => {
                  setFormData((prev) => ({ ...prev, gender: value }));
                  setErrors((prev) => ({ ...prev, gender: "" }));
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="dob"
                type="date"
                label="Date of Birth *"
                value={formatDateForInput(formData.dob)}
                onChange={handleDateChange("dob")}
                fullWidth
                size="medium"
                InputLabelProps={{ shrink: true }}
                InputProps={{ sx: { borderRadius: 3 } }}
                error={Boolean(errors.dob)}
                helperText={errors.dob}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <DropDownField
                label="Class *"
                value={formData.class}
                options={classes.map((c) => {
                  let isOptionDisabled = false;
                  let optionLabel = c.name;
                  
                  if (formData.dob && c.is_age_restricted === 1 && c.dob_from && c.dob_to) {
                    const isEligible = formData.dob >= c.dob_from && formData.dob <= c.dob_to;
                    if (!isEligible) {
                      isOptionDisabled = true;
                      optionLabel = `${c.name} (Ineligible - Age ${c.required_age}${c.required_age_max ? ` - ${c.required_age_max}` : ""})`;
                    } else {
                      optionLabel = `${c.name} (Eligible)`;
                    }
                  }
                  
                  return {
                    guid: c.guid,
                    name: optionLabel,
                    disabled: isOptionDisabled,
                  };
                })}
                error={Boolean(errors.class)}
                helperText={errors.class}
                onChange={(guid) => {
                  setFormData((prev) => ({ ...prev, class: guid }));
                  setErrors((prev) => ({ ...prev, class: "" }));
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Place of Birth"
                value={formData.placeOfBirth}
                onChange={handleChange("placeOfBirth")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Religion"
                value={formData.religion}
                onChange={handleChange("religion")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Nationality"
                value={formData.nationality}
                onChange={handleChange("nationality")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mother Tongue"
                value={formData.motherTongue}
                onChange={handleChange("motherTongue")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <DropDownField
                label="Blood Group"
                value={formData.bloodGroup}
                options={[
                  { guid: "A+", name: "A+" },
                  { guid: "A-", name: "A-" },
                  { guid: "B+", name: "B+" },
                  { guid: "B-", name: "B-" },
                  { guid: "AB+", name: "AB+" },
                  { guid: "AB-", name: "AB-" },
                  { guid: "O+", name: "O+" },
                  { guid: "O-", name: "O-" },
                ]}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    bloodGroup: value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
                Parent Information
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="parentName"
                label="Parent/Guardian Name *"
                placeholder="e.g. Rajesh Kumar"
                value={formData.parentName}
                onChange={handleChange("parentName")}
                fullWidth
                size="medium"
                error={Boolean(errors.parentName)}
                helperText={errors.parentName}
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="parentEmail"
                label="Parent Email"
                placeholder="e.g. parent@example.com"
                value={formData.parentEmail}
                onChange={handleChange("parentEmail")}
                fullWidth
                size="medium"
                helperText={errors.parentEmail}
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="parentPhone"
                label="Parent Phone *"
                placeholder="e.g. 9876543210"
                value={formData.parentPhone}
                onChange={handleChange("parentPhone")}
                onKeyDown={handleMobileKeyDown}
                fullWidth
                size="medium"
                error={Boolean(errors.parentPhone)}
                helperText={errors.parentPhone}
                InputProps={{
                  sx: {
                    borderRadius: 3,
                    bgcolor: parentData ? "rgba(76, 175, 80, 0.08)" : "inherit",
                  },
                  inputProps: {
                    maxLength: 10,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleCheckParent}
                        disabled={
                          isCheckingParent ||
                          !formData.parentPhone ||
                          formData.parentPhone.length < 10
                        }
                        edge="end"
                        sx={{
                          color: parentData ? "success.main" : "inherit",
                        }}
                      >
                        {isCheckingParent ? (
                          <CircularProgress size={20} />
                        ) : parentData ? (
                          <LockIcon color="success" />
                        ) : (
                          <SearchIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="username"
                label="User Name"
                placeholder="username"
                value={formData.username}
                onChange={handleChange("username")}
                fullWidth
                size="medium"
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="parentPassword"
                label="Parent Password"
                type={showPassword ? "text" : "password"}
                value={formData.parentPassword}
                onChange={handleChange("parentPassword")}
                fullWidth
                size="medium"
                error={Boolean(errors.parentPassword)}
                helperText={errors.parentPassword}
                InputProps={{
                  sx: { borderRadius: 3 },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="parentOccupation"
                label="Parent Occupation"
                placeholder="Parent Occupation"
                value={formData.occupation}
                onChange={handleChange("occupation")}
                fullWidth
                size="medium"
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="qualification"
                label="Qualification"
                placeholder="Qualification"
                value={formData.qualification}
                onChange={handleChange("qualification")}
                fullWidth
                size="medium"
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="placeOfWork"
                label="Place Of Work"
                placeholder="Place Of Work"
                value={formData.placeofwork}
                onChange={handleChange("placeofwork")}
                fullWidth
                size="medium"
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="address"
                label="Address"
                placeholder="Full residential address"
                value={formData.address}
                onChange={handleChange("address")}
                fullWidth
                multiline
                rows={2}
                size="medium"
                error={Boolean(errors.address)}
                helperText={errors.address}
                InputProps={{ sx: { borderRadius: 3 } }}
                InputLabelProps={{ shrink: true }}
                disabled={parentFieldsDisabled}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="joiningDate"
                type="date"
                label="Joining Date *"
                value={formatDateForInput(formData.joiningDate)}
                onChange={handleDateChange("joiningDate")}
                fullWidth
                size="medium"
                InputLabelProps={{ shrink: true }}
                InputProps={{ sx: { borderRadius: 3 } }}
                error={Boolean(errors.joiningDate)}
                helperText={errors.joiningDate}
              />
            </Grid>
          </Grid>
        );

      case 1:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
                Mother Details
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mother Name *"
                value={formData.motherName}
                onChange={handleChange("motherName")}
                fullWidth
                error={Boolean(errors.motherName)}
                helperText={errors.motherName}
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Qualification"
                value={formData.motherQualification}
                onChange={handleChange("motherQualification")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Occupation"
                value={formData.motherOccupation}
                onChange={handleChange("motherOccupation")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Place of Work"
                value={formData.motherWorkPlace}
                onChange={handleChange("motherWorkPlace")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Address"
                multiline
                rows={2}
                value={formData.motherOfficialAddress}
                onChange={handleChange("motherOfficialAddress")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Email"
                value={formData.motherEmail}
                onChange={handleChange("motherEmail")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mobile"
                value={formData.motherMobile}
                onChange={handleChange("motherMobile")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
                Medical Details
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Allergies"
                value={formData.allergies}
                onChange={handleChange("allergies")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Surgeries"
                value={formData.surgeries}
                onChange={handleChange("surgeries")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Chronic Illness"
                value={formData.chronicIllness}
                onChange={handleChange("chronicIllness")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <DropDownField
                label="Immunization"
                value={formData.immunization}
                options={[
                  { guid: "Yes", name: "Yes" },
                  { guid: "No", name: "No" },
                  { guid: "Partial", name: "Partial" },
                ]}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    immunization: value,
                  }))
                }
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
                Emergency Contact Details
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Emergency Contact Name"
                value={formData.emergencyContactName}
                onChange={handleChange("emergencyContactName")}
                fullWidth
                helperText={errors.emergencyContactName}
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Emergency Phone"
                value={formData.emergencyContactPhone}
                onChange={handleChange("emergencyContactPhone")}
                fullWidth
                helperText={errors.emergencyContactPhone}
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Relationship"
                value={formData.emergencyRelationship}
                onChange={handleChange("emergencyRelationship")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
                Guardian Details (If Applicable)
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Guardian Name"
                value={formData.guardianName}
                onChange={handleChange("guardianName")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Relationship with the child"
                value={formData.guardianRelationship}
                onChange={handleChange("guardianRelationship")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Guardian Phone"
                value={formData.guardianPhone}
                onChange={handleChange("guardianPhone")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Guardian Mobile"
                value={formData.guardianMobile}
                onChange={handleChange("guardianMobile")}
                fullWidth
                InputProps={{ sx: { borderRadius: 3 } }}
              />
            </Grid>
          </Grid>
        );

      case 2:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                14. Sibling Details
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TableContainer component={Paper} sx={{ mb: 3 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Name of the Child</TableCell>
                      <TableCell>Gender</TableCell>
                      <TableCell>Age</TableCell>
                      <TableCell>Class</TableCell>
                      <TableCell>School</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.siblings.map((sibling, index) => (
                      <TableRow key={sibling.id || index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{sibling.name}</TableCell>
                        <TableCell>{sibling.gender}</TableCell>
                        <TableCell>{sibling.age}</TableCell>
                        <TableCell>{sibling.class}</TableCell>
                        <TableCell>{sibling.school}</TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveSibling(index)}
                            color="error"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    {formData.siblings.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          No sibling details added
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={12}>
              <Paper sx={{ p: 2, mb: 3 }}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  Add New Sibling
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      label="Name of the Child"
                      value={newSibling.name}
                      onChange={handleSiblingChange("name")}
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <DropDownField
                      label="Gender"
                      value={newSibling.gender}
                      options={GENDER_OPTIONS.map((g) => ({
                        guid: g,
                        name: g,
                      }))}
                      onChange={(value) =>
                        setNewSibling((prev) => ({ ...prev, gender: value }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      label="Age"
                      value={newSibling.age}
                      onChange={handleSiblingChange("age")}
                      fullWidth
                      size="small"
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      label="Class"
                      value={newSibling.class}
                      onChange={handleSiblingChange("class")}
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      label="School"
                      value={newSibling.school}
                      onChange={handleSiblingChange("school")}
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={handleAddSibling}
                      sx={{ mt: 1 }}
                    >
                      Add Sibling
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                15. Previous School / Day Care Details
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControl component="fieldset" sx={{ mb: 3 }}>
                <FormLabel component="legend">
                  Has the child attended school / day care previously?
                </FormLabel>
                <RadioGroup
                  row
                  value={formData.previouslyAttendedSchool}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      previouslyAttendedSchool: e.target.value,
                    }))
                  }
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>

            {formData.previouslyAttendedSchool === "yes" && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Name of the school / day care"
                    value={formData.previousSchoolName}
                    onChange={handleChange("previousSchoolName")}
                    fullWidth
                    InputProps={{ sx: { borderRadius: 3 } }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Duration"
                    value={formData.previousSchoolDuration}
                    onChange={handleChange("previousSchoolDuration")}
                    fullWidth
                    InputProps={{ sx: { borderRadius: 3 } }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Class attended"
                    value={formData.previousSchoolClass}
                    onChange={handleChange("previousSchoolClass")}
                    fullWidth
                    InputProps={{ sx: { borderRadius: 3 } }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        );

      case 3:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  CHECKLIST
                </Typography>
                {mode === "edit" && (
                  <Button
                    variant="outlined"
                    onClick={toggleViewDocuments}
                    startIcon={<ImageIcon />}
                  >
                    View Uploaded Documents
                  </Button>
                )}
              </Box>
            </Grid>

            {/* Birth Certificate */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.birthCertificate}
                    onChange={handleCheckboxChange("birthCertificate")}
                  />
                }
                label="(a) Birth Certificate *"
              />
              {formData.birthCertificate && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Birth Certificate
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("birthCertificateFile")}
                    />
                  </Button>
                  {formData.birthCertificateFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.birthCertificateFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter((doc) => doc.document_type === "Birth Certificate")
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Immunization Record */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.immunizationRecord}
                    onChange={handleCheckboxChange("immunizationRecord")}
                  />
                }
                label="(b) Immunization record *"
              />
              {formData.immunizationRecord && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Immunization Record
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("immunizationRecordFile")}
                    />
                  </Button>
                  {formData.immunizationRecordFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.immunizationRecordFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter(
                      (doc) => doc.document_type === "Immunization Record",
                    )
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Transfer Certificate */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.transferCertificate}
                    onChange={handleCheckboxChange("transferCertificate")}
                  />
                }
                label="(c) Transfer Certificate (if any) **"
              />
              {formData.transferCertificate && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Transfer Certificate
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("transferCertificateFile")}
                    />
                  </Button>
                  {formData.transferCertificateFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.transferCertificateFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter(
                      (doc) => doc.document_type === "Transfer Certificate",
                    )
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Passport Photos */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.passportPhotos}
                    onChange={handleCheckboxChange("passportPhotos")}
                  />
                }
                label="(d) 4 copies passport photos of the child"
              />
              {formData.passportPhotos && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Passport Photos
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.zip,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("passportPhotosFile")}
                    />
                  </Button>
                  {formData.passportPhotosFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.passportPhotosFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter((doc) => doc.document_type === "Passport Photos")
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Progress Report */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.progressReport}
                    onChange={handleCheckboxChange("progressReport")}
                  />
                }
                label="(e) Progress report (if any) **"
              />
              {formData.progressReport && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Progress Report
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("progressReportFile")}
                    />
                  </Button>
                  {formData.progressReportFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.progressReportFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter((doc) => doc.document_type === "Progress Report")
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Passport Copy */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.passportCopy}
                    onChange={handleCheckboxChange("passportCopy")}
                  />
                }
                label="(f) Passport (for foreign students) *"
              />
              {formData.passportCopy && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Passport Copy
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("passportCopyFile")}
                    />
                  </Button>
                  {formData.passportCopyFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.passportCopyFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter((doc) => doc.document_type === "Passport Copy")
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            {/* Medical Report */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.medicalReport}
                    onChange={handleCheckboxChange("medicalReport")}
                  />
                }
                label="(g) Any other medical report *"
              />
              {formData.medicalReport && (
                <Box sx={{ ml: 4, mt: 1 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<AddPhotoAlternateIcon />}
                  >
                    Upload Medical Report
                    <input
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload("medicalReportFile")}
                    />
                  </Button>
                  {formData.medicalReportFile && (
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: "success.main" }}
                    >
                      ✓ {formData.medicalReportFile.name}
                    </Typography>
                  )}
                  {documents
                    ?.filter((doc) => doc.document_type === "Medical Report")
                    .map((doc, index) => (
                      <Box key={index} sx={{ mt: 2 }}>
                        <img
                          src={doc.file_data}
                          alt={doc.file_name}
                          style={{
                            width: 200,
                            height: "auto",
                            borderRadius: 8,
                            marginTop: 8,
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              )}
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ fontStyle: "italic", mt: 2, mb: 3 }}
              >
                Note: * Submit Photocopy ** Submit Original
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
                DECLARATION BY PARENT / GUARDIAN
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Paper sx={{ p: 3, bgcolor: "rgba(0, 0, 0, 0.02)" }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  I
                  ..........................................................................{" "}
                  <TextField
                    size="small"
                    placeholder="Parent/Guardian Name"
                    value={formData.declarationParentName}
                    onChange={handleChange("declarationParentName")}
                    error={Boolean(errors.declarationParentName)}
                    helperText={errors.declarationParentName}
                    sx={{ width: "200px", mx: 1 }}
                  />{" "}
                  ..........................................................................
                  Parent / Guardian
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  of
                  ..........................................................................{" "}
                  <TextField
                    size="small"
                    placeholder="Child Name"
                    value={formData.fullName}
                    onChange={handleChange("declarationChildName")}
                    error={Boolean(errors.declarationChildName)}
                    helperText={errors.declarationChildName}
                    sx={{ width: "200px", mx: 1 }}
                  />{" "}
                  ..........................................................................
                  do hereby understand and accept the following fully :-
                </Typography>

                <Box sx={{ pl: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    (a) I certify that the above information is correct and
                    affirm that I will abide by the rules and regulation set by
                    the school.
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    (b) In case of any accidents or illness, the school
                    authorities may take the child to the hospital / nursing
                    home as per the condition of the child.
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    (c) I will not hold the school authorities responsible for
                    any kind of mishap of my ward by events that are accidental
                    in nature.
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    (d) I shall permit the school management to take pictures of
                    my child at school and can be used for school prospectus,
                    school magazines only by keeping me informed before the use.
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    (e) The documents submitted with this form as mentioned in
                    the checklist of my child are authentic originals or true
                    copies of the documents.
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    (f) I hereby state and declare that should I or my child not
                    fulfill any one of the above conditions fully or partially
                    or have furnished false documents or incorrect information,
                    then school authorities have the right to strike off the
                    name of my child from the school rolls and my child will be
                    considered withdrawn from the school by me.
                  </Typography>
                </Box>

                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Signature of Parent / Guardian"
                      value={formData.declarationSignature}
                      onChange={handleChange("declarationSignature")}
                      fullWidth
                      InputProps={{ sx: { borderRadius: 3 } }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      type="date"
                      label="Date"
                      value={formatDateForInput(formData.declarationDate)}
                      onChange={handleDateChange("declarationDate")}
                      fullWidth
                      error={Boolean(errors.declarationDate)}
                      helperText={errors.declarationDate}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ sx: { borderRadius: 3 } }}
                    />
                  </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                  <FormControl error={Boolean(errors.declarationAccepted)}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.declarationAccepted}
                          onChange={handleCheckboxChange("declarationAccepted")}
                        />
                      }
                      label="I accept all the terms and conditions mentioned in the declaration above"
                    />
                    {errors.declarationAccepted && (
                      <FormHelperText>
                        {errors.declarationAccepted}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  const renderFileModal = () => {
    if (!selectedFile) return null;

    return ReactDOM.createPortal(
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={handleCloseFileModal}
      >
        <Box
          sx={{
            maxWidth: "90vw",
            maxHeight: "90vh",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: -40,
              right: -40,
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.7)",
              },
            }}
            onClick={handleCloseFileModal}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={selectedFile.data}
            alt={selectedFile.name}
            style={{
              maxWidth: "100%",
              maxHeight: "90vh",
              objectFit: "contain",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              position: "absolute",
              bottom: -30,
              left: 0,
              right: 0,
              textAlign: "center",
              color: "white",
            }}
          >
            {selectedFile.name}
          </Typography>
        </Box>
      </Box>,
      document.body,
    );
  };

  return ReactDOM.createPortal(
    <>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 6000,
          bgcolor: "rgba(15,23,42,0.45)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(6px)",
          display: "flex",
          justifyContent: "flex-end",
        }}
        onClick={handleClose}
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "90%", md: "75%" },
            height: "100vh",
            p: { xs: 2, md: 3 },
            boxSizing: "border-box",
            display: "flex",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Paper
            elevation={6}
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              borderRadius: 4,
              p: { xs: 3, md: 4 },
              bgcolor: "rgba(255,255,255,0.96)",
              backdropFilter: "blur(18px)",
              boxShadow:
                "0 18px 45px rgba(15,23,42,0.35), 0 0 0 1px rgba(148,163,184,0.18)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              animation: "slideIn 0.35s ease",
            }}
          >
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                bgcolor: "rgba(15,23,42,0.04)",
                "&:hover": { bgcolor: "rgba(15,23,42,0.08)" },
              }}
            >
              <CloseIcon />
            </IconButton>

            <Box
              sx={{
                mb: 3,
                pr: 5,
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                justifyContent: "space-between",
                gap: 1.5,
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    letterSpacing: 0.3,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  🎓 {mode === "edit" ? "Edit Student" : "Add New Student"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mt: 0.5 }}
                >
                  Fill in the student details below. Fields marked with * are
                  required.
                </Typography>
              </Box>

              <Chip
                label="Student Management"
                variant="outlined"
                sx={{
                  borderRadius: "999px",
                  fontSize: 12,
                  fontWeight: 500,
                  borderStyle: "dashed",
                }}
              />
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Stepper
              activeStep={activeStep}
              alternativeLabel
              sx={{
                mb: 4,
                "& .MuiStepLabel-label": {
                  fontSize: { xs: "0.7rem", sm: "0.9rem", md: "1rem" },
                },
              }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ flex: 1, overflowY: "auto", pr: 1, pb: 2 }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={9}>
                  {renderStepContent(activeStep)}
                </Grid>

                <Grid item xs={12} md={3}>
                  <Box
                    sx={{
                      borderRadius: 4,
                      p: 2.5,
                      bgcolor: "rgba(15,23,42,0.03)",
                      border: "1px solid",
                      borderColor: "rgba(148,163,184,0.3)",
                      display: "flex",
                      flexDirection: "column",
                      gap: 2.5,
                    }}
                  >
                    <FormControl error={Boolean(errors.photo)} fullWidth>
                      <Typography
                        variant="subtitle2"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        Profile Photo *
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            width: 140,
                            height: 140,
                            borderRadius: "50%",
                            border: errors.photo
                              ? "2px dashed red"
                              : "2px dashed rgba(148,163,184,0.6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "rgba(255,255,255,0.9)",
                            overflow: "hidden",
                          }}
                        >
                          {photoPreview ? (
                            <>
                              <Avatar
                                src={photoPreview}
                                alt="Profile Preview"
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemovePhoto}
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  bgcolor: "rgba(15,23,42,0.7)",
                                  color: "#fff",
                                  "&:hover": {
                                    bgcolor: "rgba(15,23,42,0.9)",
                                  },
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </>
                          ) : (
                            <AddPhotoAlternateIcon
                              sx={{
                                fontSize: 40,
                                color: errors.photo
                                  ? "error.main"
                                  : "rgba(148,163,184,0.9)",
                              }}
                            />
                          )}
                        </Box>

                        <Button
                          variant="contained"
                          component="label"
                          sx={{
                            borderRadius: 999,
                            textTransform: "none",
                            px: 3,
                            fontWeight: 500,
                          }}
                        >
                          Upload Photo
                          <input
                            hidden
                            accept="image/*"
                            type="file"
                            onChange={handlePhotoChange}
                          />
                        </Button>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            textAlign: "center",
                            px: 1,
                          }}
                        >
                          Recommended: Square image, at least 400×400px. PNG or
                          JPG only. Max 5MB.
                        </Typography>
                      </Box>

                      {errors.photo && (
                        <FormHelperText
                          error
                          sx={{ textAlign: "center", mt: 1 }}
                        >
                          {errors.photo}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl error={Boolean(parentPhotoError)} fullWidth>
                      <Typography
                        variant="subtitle2"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        Parent Profile Photo
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "50%",
                            border: parentPhotoError
                              ? "2px dashed red"
                              : "2px dashed rgba(148,163,184,0.6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "rgba(255,255,255,0.9)",
                            overflow: "hidden",
                          }}
                        >
                          {parentPhotoPreview ? (
                            <>
                              <Avatar
                                src={parentPhotoPreview}
                                alt="Parent Profile Preview"
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveParentPhoto}
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  bgcolor: "rgba(15,23,42,0.7)",
                                  color: "#fff",
                                  "&:hover": {
                                    bgcolor: "rgba(15,23,42,0.9)",
                                  },
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </>
                          ) : (
                            <AddPhotoAlternateIcon
                              sx={{
                                fontSize: 32,
                                color: parentPhotoError
                                  ? "error.main"
                                  : "rgba(148,163,184,0.9)",
                              }}
                            />
                          )}
                        </Box>

                        <Button
                          variant="outlined"
                          component="label"
                          size="small"
                          sx={{
                            borderRadius: 999,
                            textTransform: "none",
                            px: 2,
                          }}
                        >
                          Upload Parent Photo
                          <input
                            hidden
                            accept="image/*"
                            type="file"
                            onChange={handleParentPhotoChange}
                          />
                        </Button>
                      </Box>
                    </FormControl>

                    {/* Mother Photo - Show in Step 1 (Family & Medical Details) */}
                    {actualStep === 1 && (
                      <FormControl error={Boolean(motherPhotoError)} fullWidth>
                        <Typography
                          variant="subtitle2"
                          sx={{ mb: 1, fontWeight: 600 }}
                        >
                          Mother Profile Photo
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              width: 120,
                              height: 120,
                              borderRadius: "50%",
                              border: motherPhotoError
                                ? "2px dashed red"
                                : "2px dashed rgba(148,163,184,0.6)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              bgcolor: "rgba(255,255,255,0.9)",
                              overflow: "hidden",
                            }}
                          >
                            {motherPhotoPreview ? (
                              <>
                                <Avatar
                                  src={motherPhotoPreview}
                                  alt="Mother Profile Preview"
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <IconButton
                                  size="small"
                                  onClick={handleRemoveMotherPhoto}
                                  sx={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    bgcolor: "rgba(15,23,42,0.7)",
                                    color: "#fff",
                                    "&:hover": {
                                      bgcolor: "rgba(15,23,42,0.9)",
                                    },
                                  }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </>
                            ) : (
                              <AddPhotoAlternateIcon
                                sx={{
                                  fontSize: 32,
                                  color: motherPhotoError
                                    ? "error.main"
                                    : "rgba(148,163,184,0.9)",
                                }}
                              />
                            )}
                          </Box>

                          <Button
                            variant="outlined"
                            component="label"
                            size="small"
                            sx={{
                              borderRadius: 999,
                              textTransform: "none",
                              px: 2,
                            }}
                          >
                            Upload Mother Photo
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={handleMotherPhotoChange}
                            />
                          </Button>
                        </Box>
                      </FormControl>
                    )}

                    {/* Existing Info Box */}
                    <Box
                      sx={{
                        borderRadius: 3,
                        p: 1.5,
                        bgcolor:
                          mode === "edit"
                            ? "rgba(255, 152, 0, 0.04)"
                            : parentData
                              ? "rgba(76, 175, 80, 0.04)"
                              : "rgba(59,130,246,0.04)",
                        border:
                          mode === "edit"
                            ? "1px solid rgba(255, 152, 0, 0.5)"
                            : parentData
                              ? "1px solid rgba(76, 175, 80, 0.5)"
                              : "1px solid rgba(96,165,250,0.5)",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          mb: 0.5,
                          fontSize: 13,
                          color:
                            mode === "edit"
                              ? "warning.main"
                              : parentData
                                ? "success.main"
                                : "primary.main",
                        }}
                      >
                        {mode === "edit"
                          ? "Edit Mode"
                          : parentData
                            ? "Parent Found ✓"
                            : "Parent Lookup Feature"}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: "text.secondary", lineHeight: 1.6 }}
                      >
                        {mode === "edit"
                          ? "You are editing student details. Parent password is shown and can be updated."
                          : parentData
                            ? "Existing parent found! Fields are auto-filled and locked. Click 'Unlock' to edit manually."
                            : "Enter parent mobile number and press Enter or click the search icon. If parent exists, fields will auto-fill and lock."}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ mt: 4 }}
              >
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ minWidth: 100 }}
                >
                  Back
                </Button>

                {activeStep < steps.length - 1 ? (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ minWidth: 100 }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    type="button"
                    variant="contained"
                    onClick={handleSubmit}
                    color="primary"
                    sx={{ minWidth: 100 }}
                  >
                    {mode === "edit" ? "Update" : "Submit"}
                  </Button>
                )}
              </Stack>
            </Box>
          </Paper>
        </Box>

        <style>
          {`
            @keyframes slideIn {
              from { transform: translateX(100%); opacity: 0; }
              to { transform: translateX(0); opacity: 1; }
            }

            @media (max-width: 1024px) {
              .MuiGrid-item {
                width: 100% !important;
                max-width: 100% !important;
                flex-basis: 100% !important;
              }
            }
          `}
        </style>
      </Box>
      {renderFileModal()}
    </>,
    document.body,
  );
};

export default AddStudentForm;
